const FEEDBACK_REPLY_MODEL_KEY = {

  ID: 'id',
  CLASS_NAME: 'className',
  CREATED_AT: 'createdAt',
  UPDATED_AT: 'updatedAt',

  MESSAGE: 'message',
  READ_AT: 'readAt',

  // Associations
  PROFILE_ID: 'profileId',
  FEEDBACK_ID: 'feedbackId'

}

const FEEDBACK_REPLY_MODEL_CLASS_NAME = 'FeedbackReply'

export {
  FEEDBACK_REPLY_MODEL_CLASS_NAME,
  FEEDBACK_REPLY_MODEL_KEY
}
